import React from "react";
import PropTypes from "prop-types";
import { Modal, Space } from "antd";
import RegistrationFormWrapper from "./RegistrationFormWrapper";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";

const SSOModal = ({ handleSubmit, application, onClose, isEdit, open }) => (
  <Modal
    title={
      <Space>
        {isEdit ? <EditOutlined /> : <PlusOutlined />}
        {isEdit ? `Edit CERN SSO Registration` : "New CERN SSO Registration"}
      </Space>
    }
    open={open}
    onCancel={onClose}
    footer={null}
    width={800}
    centered
    closable
  >
    <RegistrationFormWrapper
      isEdit={isEdit}
      handleSubmit={handleSubmit}
      application={application}
    />
  </Modal>
);

SSOModal.propTypes = {
  application: PropTypes.object,
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  isEdit: PropTypes.bool,
};
export default SSOModal;
